import { PureComponent } from "react";
import { StyledScrollTopFabComponent } from "./scroll-top-fab-component.scss";
import ArrowUp from "/static/svg/careers/up.svg";
import classnames from "classnames";

class ScrollTopFabComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };
  }
  componentDidMount() {
    if (typeof window !== "undefined") {
      window.onscroll = () => {
        let currentScrollPos = window.pageYOffset;
        let maxScroll = document.body.scrollHeight - window.innerHeight;
        if (currentScrollPos > 0 && currentScrollPos < maxScroll) {
          this.setState({ show: true })
        } else {
          this.setState({ show: false })
        }
      }
    }
  }

  onClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  render() {
    const { wrapperStyles } = this.props;
    const { show } = this.state;

    return (
      <StyledScrollTopFabComponent className={classnames("scroll-top-fab-component", "tooltip-trigger", {
        "is-shown": show
      })} style={{ ...wrapperStyles }} onClick={this.onClick}>
        <div>
          <ArrowUp />
          <div className="tooltip-contents">
            Return to top
          </div>
        </div>
      </StyledScrollTopFabComponent>
    );
  }
}

ScrollTopFabComponent.defaultProps = {
  wrapperStyles: {}
};

export default ScrollTopFabComponent;
